// extracted by mini-css-extract-plugin
export default {"backToTop":"BackToTopButton_backToTop__F62uq"};